import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';

const Events = () => {
  const upcomingEvents = [
    {
      date: 'xxxxxxxxx',
      title: 'Dairy Value Addition Training Program',
      location: 'xxxxxxxxxx',
      description: 'Comprehensive training on dairy product processing and value addition techniques',
      type: 'Training',
      status: 'Upcoming'
    },
    {
      date: 'xxxxxxxxxx',
      title: 'Village Awareness Camp ',
      location: 'xxxxxxxxxxx',
      description: 'Community health and dairy nutrition awareness program',
      type: 'Awareness',
      status: 'Upcoming'
    },
    {
      date: 'xxxxxxxxxx',
      title: 'SHG Leadership Development Workshop',
      location: 'xxxxxxxxxx',
      description: 'Leadership skills development for SHG coordinators and members',
      type: 'Workshop',
      status: 'Upcoming'
    }
  ];

  const pastEvents = [
    {
      date: 'February 10, 2024',
      title: 'Tamil Nadu Startup Launchpad',
      location: 'Chennai Trade Centre',
      description: 'Product launched by the Hon’ble Minister for MSME at the Tamil Startup Launch Pad Showcased WiSE products and services at the state startup exhibition',
      type: 'Exhibition',
      status: 'Completed',
      outcome: 'Generated significant interest from potential partners and customers'
    },
    {
      date: 'January 28, 2024',
      title: 'Dairy Health Camp - Vathiyur',
      location: 'Vathiyur Village',
      description: 'Free health checkup camp for dairy animals and nutrition awareness',
      type: 'Health Camp',
      status: 'Completed',
      outcome: 'Reached 50+ farmers and treated 30+ animals'
    },
    {
      date: 'December 15, 2023',
      title: 'Product Launch - Diet Yoghurt',
      location: 'WiSE Headquarters',
      description: 'Official launch of healthy millet-based ice cream products',
      type: 'Product Launch',
      status: 'Completed',
      outcome: 'Positive response from media and customers'
    },
    {
      date: 'November 20, 2023',
      title: 'CFDT Training Program',
      location: 'CFDT Campus',
      description: 'Advanced dairy processing techniques and quality control training',
      type: 'Training',
      status: 'Completed',
      outcome: '25 SHG members successfully completed certification'
    },
    {
      date: 'October 8, 2023',
      title: 'Government Recognition Ceremony',
      location: 'TANUVAS – TN Startup Agri Marketing Initiative',
      description: 'Official recognition ceremony by Tamil Nadu Government',
      type: 'Award',
      status: 'Completed',
      outcome: 'Received official recognition and support'
    }
  ];

  const newsUpdates = [
    {
      date: 'March 1, 2024',
      title: 'WiSE Wins Best Rural Innovation Award',
      description: 'Recognized for outstanding contribution to rural women empowerment through dairy entrepreneurship',
      category: 'Award'
    },
    {
      date: 'February 15, 2024',
      title: 'New Partnership with Local NGOs',
      description: 'Strategic partnership to expand reach to more villages in Tamil Nadu',
      category: 'Partnership'
    },
    {
      date: 'January 30, 2024',
      title: 'IoT Technology Upgrade Complete',
      description: 'Latest milk analyzer technology deployed across all collection centers',
      category: 'Technology'
    },
    {
      date: 'December 28, 2023',
      title: 'Record Monthly Production',
      description: 'Achieved highest ever monthly milk collection of 15,000 liters',
      category: 'Milestone'
    }
  ];

  const getBadgeColor = (type) => {
    switch (type) {
      case 'Training': return 'primary';
      case 'Workshop': return 'info';
      case 'Awareness': return 'success';
      case 'Health Camp': return 'warning';
      case 'Exhibition': return 'secondary';
      case 'Product Launch': return 'danger';
      case 'Award': return 'warning';
      default: return 'light';
    }
  };

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section className="py-5 text-white hero_sec" style={{ background: 'linear-gradient(135deg, #2E8B57, #4682B4)' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-3">Events & News</h1>
              <p className="fs-5">Stay updated with our latest activities, achievements, and upcoming programs</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Upcoming Events */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Upcoming Events</h2>
              <p className="fs-5 text-muted">Join us in our upcoming programs and activities</p>
            </Col>
          </Row>
          <Row>
            {upcomingEvents.map((event, index) => (
              <Col md={4} key={index} className="mb-4">
                <Card className="border-0 shadow card-hover h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <Badge bg={getBadgeColor(event.type)}>{event.type}</Badge>
                      <Badge bg="success">{event.status}</Badge>
                    </div>
                    <Card.Title className="fw-bold h5">{event.title}</Card.Title>
                    <div className="mb-2">
                      <small className="text-primary fw-semibold">📅 {event.date}</small>
                    </div>
                    <div className="mb-3">
                      <small className="text-muted">📍 {event.location}</small>
                    </div>
                    <Card.Text className="text-muted">{event.description}</Card.Text>
                    <button className="btn btn-outline-primary btn-sm">Register Interest</button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* News & Updates */}
      <section className="section-padding" style={{ backgroundColor: '#f8f9fa' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Latest News & Updates</h2>
              <p className="fs-5 text-muted">Recent achievements and milestones</p>
            </Col>
          </Row>
          <Row>
            {newsUpdates.map((news, index) => (
              <Col md={6} key={index} className="mb-4">
                <Card className="border-0 shadow-sm hover-lift h-100">
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <Badge bg="info">{news.category}</Badge>
                      <small className="text-muted">{news.date}</small>
                    </div>
                    <Card.Title className="fw-bold h5">{news.title}</Card.Title>
                    <Card.Text className="text-muted">{news.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Past Events */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Past Events & Achievements</h2>
              <p className="fs-5 text-muted">Our journey of successful programs and milestones</p>
            </Col>
          </Row>
          <Row>
            {pastEvents.map((event, index) => (
              <Col lg={6} key={index} className="mb-4">
                <Card className="border-0 shadow-sm hover-lift">
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <Badge bg={getBadgeColor(event.type)}>{event.type}</Badge>
                      <div className="text-end">
                        <Badge bg="secondary">{event.status}</Badge>
                        <div className="mt-1">
                          <small className="text-muted">{event.date}</small>
                        </div>
                      </div>
                    </div>
                    <Card.Title className="fw-bold h5">{event.title}</Card.Title>
                    <div className="mb-3">
                      <small className="text-muted">📍 {event.location}</small>
                    </div>
                    <Card.Text className="text-muted mb-3">{event.description}</Card.Text>
                    {event.outcome && (
                      <div className="border-start border-success ps-3 bg-light p-2 rounded">
                        <small className="text-success fw-semibold">Outcome: </small>
                        <small>{event.outcome}</small>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Event Calendar */}
      <section className="py-5 text-white" style={{ background: 'linear-gradient(135deg, #2E8B57, #4682B4)' }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Event Calendar 2024</h2>
              <p className="fs-5 mb-4">Stay connected with our regular programs throughout the year</p>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <div className="bg-white bg-opacity-10 p-3 rounded">
                    <h6 className="fw-bold">Monthly Training</h6>
                    <small>Every 3rd Saturday</small>
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <div className="bg-white bg-opacity-10 p-3 rounded">
                    <h6 className="fw-bold">Village Camps</h6>
                    <small>Bi-monthly visits</small>
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <div className="bg-white bg-opacity-10 p-3 rounded">
                    <h6 className="fw-bold">Health Camps</h6>
                    <small>Quarterly programs</small>
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <div className="bg-white bg-opacity-10 p-3 rounded">
                    <h6 className="fw-bold">Exhibitions</h6>
                    <small>As opportunities arise</small>
                  </div>
                </div>
              </div>
              <button className="btn btn-light btn-lg px-4 mt-4">
                Subscribe for Updates
              </button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Events;